<template>
    <div class="modal" data-backdrop="static" id="bsProjectTimeLogSaveFormDialog" ref="bsProjectTimeLogSaveFormDialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content viewDetails">
                <form name="saveProjectTimeLog"
                      :action="pUrls['saveProjectTimeLog']"
                      method="post" class="ajax-support show-waiting"
                      data-ajax-support-csv="#ajaxModuleForm,#projectTimeLogListHeader,#projectTimeLogListBody,#projectTimeLogViewBody">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span>
                        </button>
                        <h3 class="modal-title">{{ title }}</h3>
                    </div>
                    <div class="modal-body max-height bs3-padding-top-reset bs3-padding-bottom-reset">

                        <input type="hidden" name="dataForm.data.id" :value="data.id"/>

                        <input type="hidden" name="src" :value="pSrc"/>
                        <input type="hidden" name="srcId" :value="pSrcId"/>

                        <input type="hidden" name="dataForm.data.mediaWorkRef.id" :value="data.mediaWorkRef.id"/>
                        <input type="hidden" name="dataForm.mediaWorkCorrectionId" :value="pDataForm.mediaWorkCorrectionId"/>

                        <div v-if="nbOfErrors > 0">
                            <div class="bs3-padding text-center bs3-margin-left-minus15 bs3-margin-right-minus15 bg-danger">
                                <span class="label label-danger">{{ nbOfErrors | error(pDictionary) }}</span>
                            </div>
                        </div>

                        <div class="bs3-padding-y">
                            <div class="row">
                                <div class="col-xs-6">
                                    <!--
                                     - USER
                                     --->
                                    <div :class="['form-group', {'has-error': hasFieldErrors('dataForm.data.userRef')}]">
                                        <div v-if="hasFieldErrors('dataForm.data.userRef')">
                                    <span v-for="error in getFieldErrors('dataForm.data.userRef')"
                                          class="help-block bs3-margin-top-reset bs3-margin-bottom5" :key="error">{{ error }}</span>
                                        </div>
                                        <label v-else for="projectTimeLog_userRef">
                                            <span class="required">*</span> {{ pDictionary['dictionary.project.timelog.user'] }}
                                        </label>
                                        <p id="projectTimeLog_userRef" class="form-control-static">
                                            {{ data.userRef.name }}
                                        </p>
                                    </div>
                                </div>
                                <div class="col-xs-6">
                                    <!--
                                   - ROLE
                                   --->
                                    <role-select
                                            v-model="roleId"
                                            :p-currencies="pCurrencies"
                                            :p-language="pLanguage"
                                            :p-dictionary="pDictionary"
                                            :p-urls="pUrls"
                                            :p-error-list="pErrorList"
                                            :p-src="pSrc"
                                            :p-src-id="pSrcId"
                                            :p-label-visible="true"
                                            :p-error-key="'dataForm.data.roleRef'"
                                            :p-input-name="'dataForm.data.roleRef.id'"
                                            :p-data-list-input="roleDataListInput"
                                            p-select-container="#bsProjectTimeLogSaveFormDialog">
                                    </role-select>
                                </div>
                            </div>

                            <!--
                             - DESCRIPTION
                             --->
                            <div :class="['form-group', {'has-error': hasFieldErrors('dataForm.data.description')}]">
                                <div v-if="hasFieldErrors('dataForm.data.description')">
                                    <span v-for="error in getFieldErrors('dataForm.data.description')"
                                          class="help-block bs3-margin-top-reset bs3-margin-bottom5" :key="error">{{ error }}</span>
                                </div>
                                <label v-else for="projectTimeLog_Description">
                                    <span class="required">*</span> {{ pDictionary['dictionary.project.timelog.description'] }}
                                </label>
                                <textarea rows="5" v-model="data.description"
                                          name="dataForm.data.description" class="form-control"
                                          :placeholder="pDictionary['dictionary.project.timelog.description.placeholder']"></textarea>
                            </div>

                            <div class="row">
                                <div class="col-xs-4">
                                    <!--
                                     - MODE
                                     --->
                                    <div :class="['form-group', {'has-error': hasFieldErrors('dataForm.data.modeText')}]">
                                        <div v-if="hasFieldErrors('dataForm.data.modeText')">
                                    <span v-for="error in getFieldErrors('dataForm.data.modeText')"
                                          class="help-block bs3-margin-top-reset bs3-margin-bottom5" :key="error">{{ error }}</span>
                                        </div>
                                        <label v-else for="projectTimeLog_ModeText">
                                            <span class="required">*</span> {{ pDictionary['dictionary.project.timelog.mode'] }}
                                        </label>
                                        <p id="projectTimeLog_ModeText" class="form-control-static">
                                            <label class="radio-inline bs3-label">
                                                <input type="radio" name="dataForm.data.modeText" id="projectTimeLog_ModeText_MANUAL"
                                                       v-model="data.modeText" value="MANUAL">
                                                {{ pDictionary['dictionary.project.timelog.mode.MANUAL'] }}
                                            </label>
                                            <label class="radio-inline bs3-label">
                                                <input type="radio" name="dataForm.data.modeText" id="projectTimeLog_ModeText_TIMER"
                                                       v-model="data.modeText" :disabled="timerDisabled" value="TIMER">
                                                {{ pDictionary['dictionary.project.timelog.mode.TIMER'] }}
                                            </label>
                                        </p>
                                    </div>
                                </div>
                                <div class="col-xs-8" v-if="timerVisible">
                                    <div class="form-group">
                                        <label for="projectTimeLog_dateText" class="sr-only">
                                            Timer
                                        </label>
                                        <div class="input-group bs3-margin-top30">
                                            <span class="input-group-addon" id="basic-addon1">
                                                <i class="fa-light fa-stopwatch"></i>
                                                <span class="bs3-margin-left3">{{
                                                    pDictionary['dictionary.project.timelog.mode.TIMER.running']
                                                    }}</span>
                                            </span>
                                            <input type="text" class="form-control text-center"
                                                   :value="timerNbOfHours" disabled>
                                            <span class="input-group-btn">
                                                <button class="btn btn-danger" type="button" @click="stopTimer">
                                                    <i class="fa-light fa-stop"></i>
                                                    <span class="bs3-margin-left3">{{
                                                        pDictionary['dictionary.project.timelog.mode.TIMER.stop.short']
                                                        }}</span>
                                                </button>
                                          </span>
                                        </div>
                                    </div>

                                </div>
                                <div class="col-xs-4" v-if="dateVisible">
                                    <!--
                                     - DATE
                                     --->
                                    <div :class="['form-group', {'has-error': hasFieldErrors('dataForm.data.dateText')}]">
                                        <div v-if="hasFieldErrors('dataForm.data.dateText')">
                                    <span v-for="error in getFieldErrors('dataForm.data.dateText')"
                                          class="help-block bs3-margin-top-reset bs3-margin-bottom5" :key="error">{{ error }}</span>
                                        </div>
                                        <label v-else for="projectTimeLog_dateText">
                                            <span class="required">*</span> {{ pDictionary['dictionary.project.timelog.date'] }}
                                        </label>
                                        <div class="input-group">
                                            <span class="input-group-addon"><i class="fa-light fa-calendar"></i></span>
                                            <input type="text" ref="dateText"
                                                   id="projectTimeLog_dateText"
                                                   name="dataForm.data.dateText"
                                                   :placeholder="pDictionary['dictionary.format.date.hint']"
                                                   v-model="data.dateText"
                                                   size="10" maxlength="10"
                                                   class="form-control datepicker dateText"
                                                   autocomplete="off">
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xs-4" v-if="nbHoursVisible">
                                    <!--
                                     - NB HOURS
                                     --->
                                    <div :class="['form-group', {'has-error': hasFieldErrors('dataForm.data.nbHours')}]">
                                        <div v-if="hasFieldErrors('dataForm.data.nbHours')">
                                    <span v-for="error in getFieldErrors('dataForm.data.nbHours')"
                                          class="help-block bs3-margin-top-reset bs3-margin-bottom5" :key="error">{{ error }}</span>
                                        </div>
                                        <label v-else for="projectTimeLog_NbHours">
                                            <span class="required">*</span> {{ pDictionary['dictionary.project.timelog.nb.hours'] }}
                                        </label>
                                        <input id="projectTimeLog_NbHours"
                                               type="text" v-model="data.nbHours"
                                               name="dataForm.data.nbHours" class="form-control"
                                               :placeholder="pDictionary['dictionary.project.timelog.nb.hours.placeholder']"/>
                                    </div>
                                </div>
                                <div class="col-xs-4" v-if="timerInitialStateVisible">
                                    <!--
                                     - TIMER STATUS
                                     --->
                                    <div :class="['form-group', {'has-error': hasFieldErrors('dataForm.data.timerAutoStart')}]">
                                        <div v-if="hasFieldErrors('dataForm.data.timerAutoStart')">
                                    <span v-for="error in getFieldErrors('dataForm.data.timerAutoStart')"
                                          class="help-block bs3-margin-top-reset bs3-margin-bottom5" :key="error">{{ error }}</span>
                                        </div>
                                        <label v-else for="projectTimeLog_timerAutoStart">
                                            <span class="required">*</span> {{ pDictionary['dictionary.project.timelog.mode.TIMER.auto-start'] }}
                                        </label>
                                        <p id="projectTimeLog_timerAutoStart" class="form-control-static">
                                            <label class="radio-inline bs3-label">
                                                <input type="radio" name="dataForm.data.timerAutoStart" id="projectTimeLog_timerAutoStart_TRUE"
                                                       v-model="data.timerAutoStart" value="true">
                                                {{ pDictionary['dictionary.project.timelog.mode.TIMER.auto-start.yes'] }}
                                            </label>
                                            <label class="radio-inline bs3-label">
                                                <input type="radio" name="dataForm.data.timerAutoStart" id="projectTimeLog_timerAutoStart_FALSE"
                                                       v-model="data.timerAutoStart" value="false">
                                                {{ pDictionary['dictionary.project.timelog.mode.TIMER.auto-start.no'] }}
                                            </label>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <div class="text-right">
                            <button type="submit" class="btn btn-primary">
                                <i class="fa-light fa-check"></i> <span>{{ saveButtonLabel }}</span>
                            </button>
                            <a href="#"
                               class="btn btn-link" data-dismiss="modal" aria-label="Cancel">{{
                                pDictionary['dictionary.actions.cancel']
                                }}</a>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import BaseMixin from "@/mixins/base-mixin";
import FormMixin from "@/mixins/form-mixin";
import FormatMixin from "@/mixins/format-mixin";
import refHelpers from "@/helpers/ref-helpers";
import RoleSelect from "@/components/modules/administration-module/role/RoleSelect.vue";
import dateHelpers from "@/helpers/date-helpers";

export default {
   name: "ProjectTimeLogSaveForm.vue",
   components: {RoleSelect},
   mixins: [BaseMixin, FormMixin, FormatMixin],
   props: {
      pDataForm: Object
   },
   data: function () {
      return {
         data: this.pDataForm.data,
         roleId: refHelpers.getRefId(this.pDataForm.data.roleRef, null),
         errorList: [],
         nowMillis: Date.now()
      }
   },
   methods: {
      isIdValid: function () {
         return this.data.id !== undefined
                && this.data.id > 0;
      },
      stopTimer: function () {
         this.data.nbHours = dateHelpers.getNbHours(this.nowMillis - this.data.timerStartDateTimeMillis, 2);
         this.data.modeText = 'MANUAL';
      },
      refreshNow: function () {
         let _component = this;
         _component.nowMillis = Date.now();
         setTimeout(() => {
            _component.refreshNow();
         }, 1000);
      }
   },
   computed: {
      title: function () {
         return this.isIdValid()
                ? this.pDictionary['dictionary.project.timelog.udate.title']
                : this.pDictionary['dictionary.project.timelog.create.title'];
      },
      saveButtonLabel: function () {
         return this.data.modeText === 'TIMER' && !this.isIdValid() && this.data.timerAutoStart
                ? this.pDictionary['dictionary.project.timelog.mode.TIMER.start']
                : this.pDictionary['dictionary.actions.save'];
      },
      roleDataListInput: function () {
         return {
            userIds: [refHelpers.getRefId(this.data.userRef, 0)]
         }
      },
      timerDisabled: function () {
         return this.isIdValid() && this.data.timerStartDateTimeMillis === 0;
      },
      timerVisible: function () {
         return this.data.modeText === 'TIMER' && this.isIdValid();
      },
      timerNbOfHours: function () {
         return dateHelpers.millisToHMS(this.nowMillis - this.data.timerStartDateTimeMillis);
      },
      dateVisible: function () {
         return this.data.modeText !== 'TIMER';
      },
      nbHoursVisible: function () {
         return this.data.modeText !== 'TIMER';
      },
       timerInitialStateVisible: function () {
           return this.data.modeText === 'TIMER';
       }
   },
   mounted: function () {
      let _component = this;

      _component.refreshNow();

      let $bsProjectTimeLogSaveFormDialog = $(this.$refs.bsProjectTimeLogSaveFormDialog);
      $bsProjectTimeLogSaveFormDialog.on('shown.bs.modal', function () {
         // Init DateText.
         let $dateText = $(_component.$refs.dateText);
         $dateText.initFromDatePicker(
                 {
                    dateElId: $dateText.attr('id'),
                    linkDateElId: null,
                    bs3: true,
                    f: function (selectedDate) {
                       _component.$data.data.dateText = selectedDate;
                       _component.$refs.dateText.dispatchEvent(new Event('change'));
                    }, noWeekends: false
                 });
      });

      $bsProjectTimeLogSaveFormDialog.on('hidden.bs.modal', function () {

      });

      $(_component.$refs.bsProjectTimeLogSaveFormDialog).modal();
   }
}
</script>

<style scoped>

</style>